// extracted by mini-css-extract-plugin
module.exports = {"zigzagCardText":"VolunteerCircularImage_zigzagCardText__Q79Yf","wTitle":"VolunteerCircularImage_wTitle__vPvet","wTitle1":"VolunteerCircularImage_wTitle1__B2drr"};